import {
  StoreTiles,
  CreateStoreSetup,
  MRRReportCreate,
  MRRReportList,
  StoreResisterPart,
  StockResister,
  ViewStore,
} from '../../pages/storeManagement';

export const storeManagament = [
  {
    path: 'storeManagement',
    element: <StoreTiles />,
  },
  {
    path: 'createStoreSetup',
    element: <CreateStoreSetup />,
  },
  {
    path: 'mrrReport/list',
    element: <MRRReportList />,
  },
  {
    path: 'mrrReport/view/:supplierId/:id?',
    element: <MRRReportCreate />,
  },
  {
    path: 'storeregister/part/list',
    element: <StoreResisterPart />,
  },
  {
    path: 'storeregister/log/list/:riPartId',
    element: <StockResister />,
  },
  {
    path: 'viewStore',
    element: <ViewStore />,
  },
];
